import { createSlice } from "@reduxjs/toolkit";
import { FileAPI } from "../../services/file";

const FileSlice = createSlice({
  name: "File",
  initialState: {
    fileInfo: null,
    listFile: [],
  },
  reducers: {
    setFile: (state, action) => {
      state.fileInfo = action.payload;
    },
    setListFile: (state, action) => {
      state.listFile = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(FileAPI.postUploadFiles.fulfilled, (state, action) => {
      state.listFile = [action.payload];
    });
  },
});

export const { setFile, setListFile } = FileSlice.actions;

export default FileSlice;
